import { render } from "./NoItems.vue?vue&type=template&id=f040fb7e"
import script from "./NoItems.vue?vue&type=script&lang=js"
export * from "./NoItems.vue?vue&type=script&lang=js"

import "./NoItems.vue?vue&type=style&index=0&id=f040fb7e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__